import { useEffect } from 'react'

/**
 * Calls `onClickOutside` when a mousedown event occurs outside all provided refs.
 * Set `enabled` to `false` to suspend the listener (e.g. when a panel is closed).
 */
export function useClickOutside(
  refs: { current: HTMLElement | null }[],
  onClickOutside: () => void,
  enabled = true
) {
  useEffect(() => {
    if (!enabled) return
    const handleMouseDown = (e: MouseEvent) => {
      const target = e.target as Node
      if (refs.every((ref) => !ref.current?.contains(target))) {
        onClickOutside()
      }
    }
    document.addEventListener('mousedown', handleMouseDown)
    return () => document.removeEventListener('mousedown', handleMouseDown)
    // refs are stable React ref objects — intentionally omitted from deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, onClickOutside])
}
